module.exports = ":host {\n  height: 100%;\n  width: 100%; }\n\n.example-headers-align .mat-expansion-panel-header-title,\n.example-headers-align .mat-expansion-panel-header-description {\n  -ms-flex-preferred-size: 0;\n      flex-basis: 0; }\n\n.example-headers-align .mat-expansion-panel-header-description {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/businessRule/components/rule-tile.component.scss
// module id = ./src/app/businessRule/components/rule-tile.component.scss
// module chunks = main